/**
 * Pasos que siguen accionables una vez superados: 2.1 permite añadir y modificar intervinientes en
 * cualquier momento, y 2.2.2 / 2.4.3 deben dejar rehacer el test de idoneidad para siempre desde que
 * se habilitan por primera vez (el perfil de riesgo del interviniente puede cambiar tras contratar).
 */
export const ReentrantContractStepKeys = ["2.1", "2.2.2", "2.4.3"];

export function isReentrantContractStepKey(key: string): boolean
{
    return ReentrantContractStepKeys.includes(key);
}

export function isSuitabilityContractStepKey(key: string): boolean
{
    return key === "2.2.2" || key === "2.4.3";
}
